import styled, { css } from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-ut0v9w-0"
})(["display:flex;font-weight:700;color:", ";", " svg{position:relative;top:3px;left:4px;align-self:center;margin-left:auto;margin-right:4px;color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
}, function (props) {
  return props.open && css(["svg{transform:rotate(180deg);}"]);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.terciaryDD;
});